import request from '@/utils/request'

let LangApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._post('/shop/plus.lang.lang/getLang', data, errorback);
  },
  submit(data, errorback) {
    return request._post('/shop/plus.lang.lang/submit', data, errorback);
  },
}

export default LangApi;



// WEBPACK FOOTER //
// ./src/api/lang.js